import { CommonModule, KeyValuePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { TimeInputComponent } from 'core/time-input/time-input.component';
import { DsAngularModule } from '@snapon/design-system-angular';
import { AppMaterialModule } from '../../app-material.module';
import { SharedModule } from '../shared/shared.module';
import { SyncStepperComponent } from '../shared/sync-stepper/sync-stepper.component';
import { MarketingModule } from '../marketing/marketing.module';
import { PosModule } from '../pos/pos.module';
import { AccountsDetailComponent } from './accounts/accounts-detail/accounts-detail.component';
import { AccountsInfoWidgetComponent } from './accounts/accounts-detail/accounts-info-widget/accounts-info-widget.component';
import { AccountsAdvancedSearchComponent } from './accounts/accounts-list/accounts-advanced-search/accounts-advanced-search.component';
import { AccountsListFilterFormComponent } from './accounts/accounts-list/accounts-filter-form/accounts-filter-form.component';
import { AccountsListTableComponent } from './accounts/accounts-list/accounts-list-table/accounts-list-table.component';
import { PowerBiReportComponent } from './dashboard/power-bi-report/power-bi-report.component';
import { ContactsDashboardComponent } from './contacts/contacts-dashboard/contacts-dashboard.component';
import { ContactsListComponent } from './contacts/contacts-list/contacts-list.component';
import { CrmRoutingModule } from './crm-routing.module';
import { ApplicationStatusWidgetComponent } from './dashboard/application-status-widget/application-status-widget.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ErrorListComponent } from './dashboard/error-list/error-list.component';
import { QuotesWidgetComponent } from './dashboard/quotes-widget/quotes-widget.component';
import { SyncHistoryComponent } from './dashboard/sync-history/sync-history.component';
import { ToggleOnlineStatusWidgetComponent } from './dashboard/toggle-online-status-widget/toggle-online-status-widget.component';
import { TouchpointsWidgetComponent } from './dashboard/touchpoints-widget/touchpoints-widget.component';
import { LeadsDeleteComponent } from './leads/delete-lead/leads-delete.component';
import { EditLeadComponent } from './leads/edit-lead/edit-lead.component';
import { LeadsComponent } from './leads/leads.component';
import { LeadsRejectComponent } from './leads/merge-leads/leads-reject/leads-reject.component';
import { EditTouchpointComponent } from './touchpoints/edit-touchpoint/edit-touchpoint.component';
import { TouchpointsComponent } from './touchpoints/touchpoints.component';
import { ViewOfflineStatusComponent } from './view-offline-status/view-offline-status.component';
import { NotesWidgetComponent } from './dashboard/notes-widget/notes-widget.component';
import { ManageContactsTouchpointsComponent } from './touchpoints/manage-contacts-touchpoints/manage-contacts-touchpoints.component';
import { LnOrdersComponent } from './dashboard/last-ten/ln-orders/ln-orders.component';
import { FollowUpComponent } from './dashboard/follow-up/follow-up.component';
import { LeadsTableComponent } from './dashboard/follow-up/leads-table/leads-table.component';
import { EditLeadDialogComponent } from './dashboard/follow-up/leads-table/edit-lead-dialog/edit-lead-dialog.component';
import { LeadNotesComponent } from './dashboard/follow-up/leads-table/lead-notes/lead-notes.component';
import { LeadsSearchComponent } from './dashboard/follow-up/leads-table/leads-search/leads-search.component';
import { LastTenComponent } from './dashboard/last-ten/last-ten.component';
import { OpenQuotesComponent } from './dashboard/last-ten/open-quotes/open-quotes.component';
import { QuotesSearchComponent } from './dashboard/last-ten/quotes-search/quotes-search.component';
import { TrackingNumbersComponent } from './dashboard/last-ten/tracking-numbers/tracking-numbers.component';
import { DailyTouchpointsComponent } from './dashboard/daily-touchpoints/daily-touchpoints.component';
import { ProjectsTableComponent } from './dashboard/follow-up/projects-table/projects-table.component';
import { EditProjectDialogComponent } from './dashboard/follow-up/projects-table/edit-project-dialog/edit-project-dialog.component';
import { ProjectsSearchComponent } from './dashboard/follow-up/projects-table/projects-search/projects-search.component';
import { FollowUpSearchComponent } from './dashboard/follow-up/follow-up-search/follow-up-search.component';
import { ProjectNotesComponent } from './dashboard/follow-up/projects-table/project-notes/project-notes.component';
import { B2bUsersComponent } from './b2b-users/b2b-users.component';
import { B2bUserCartComponent } from './b2b-users/b2b-user-cart/b2b-user-cart.component';
import { B2bEditCartComponent } from './b2b-users/b2b-edit-cart/b2b-edit-cart.component';
import { B2bCartNotificationsComponent } from './b2b-users/b2b-cart-notifications/b2b-cart-notifications.component';
import { B2bCartSummaryNotificationsComponent } from './b2b-users/b2b-cart-summary-notifications/b2b-cart-summary-notifications.component';
import { B2bCartItemDialogComponent } from './b2b-users/b2b-cart-item-dialog/b2b-cart-item-dialog.component';
import { MergeLeadModalComponent } from './accounts/accounts-list/merge-lead-modal/merge-lead-modal.component';
import { MergeTouchpointModalComponent } from './touchpoints/merge-touchpoint-modal/merge-touchpoint-modal.component';
import { MergeContactModalComponent } from './touchpoints/merge-contact-modal/merge-contact-modal.component';
import { TouchpointDetailComponent } from './touchpoints/touchpoint-detail/touchpoint-detail.component';

@NgModule({
  declarations: [
    TouchpointsWidgetComponent,
    DashboardComponent,
    TouchpointsComponent,
    AccountsListFilterFormComponent,
    AccountsListTableComponent,
    EditTouchpointComponent,
    TimeInputComponent,
    AccountsDetailComponent,
    ContactsDashboardComponent,
    ContactsListComponent,
    LeadsComponent,
    QuotesWidgetComponent,
    EditLeadComponent,
    AccountsInfoWidgetComponent,
    LeadsDeleteComponent,
    LeadsRejectComponent,
    PowerBiReportComponent,
    AccountsAdvancedSearchComponent,
    SyncStepperComponent,
    ApplicationStatusWidgetComponent,
    ViewOfflineStatusComponent,
    ErrorListComponent,
    SyncHistoryComponent,
    ToggleOnlineStatusWidgetComponent,
    NotesWidgetComponent,
    ManageContactsTouchpointsComponent,
    LnOrdersComponent,
    FollowUpComponent,
    FollowUpSearchComponent,
    LeadsTableComponent,
    EditLeadDialogComponent,
    LeadNotesComponent,
    LeadsSearchComponent,
    LastTenComponent,
    OpenQuotesComponent,
    QuotesSearchComponent,
    TrackingNumbersComponent,
    DailyTouchpointsComponent,
    ProjectsTableComponent,
    EditProjectDialogComponent,
    ProjectsSearchComponent,
    ProjectNotesComponent,
    B2bUsersComponent,
    B2bUserCartComponent,
    B2bEditCartComponent,
    B2bCartNotificationsComponent,
    B2bCartSummaryNotificationsComponent,
    B2bCartItemDialogComponent,
    MergeLeadModalComponent,
    MergeTouchpointModalComponent,
    MergeContactModalComponent,
    TouchpointDetailComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CrmRoutingModule,
    AppMaterialModule,
    MatGridListModule,
    MarketingModule,
    DsAngularModule,
    PosModule
  ],
  providers: [
    KeyValuePipe
  ]
})
export class CrmModule { }
